/**
 * Notifications Container Component
 * A React component that manages and displays multiple notification messages
 * Acts as a container for individual Notification components and manages their positioning
 */

import React from "react";
import { useSelector } from "react-redux";
import Notification from "./notification";

/**
 * Container component for rendering multiple notifications
 * Retrieves notifications from Redux store and renders them in a fixed position
 * @returns {JSX.Element|null} Rendered notifications container or null if no notifications
 */
const NotificationsContainer = () => {
  /**
   * Select notifications from Redux store
   * @type {Array<{id: string, message: string, type: string}>}
   */
  const notifications = useSelector((state) => state.notifications);

  /**
   * Early return if no notifications exist
   */
  if (!notifications || notifications.length === 0) {
    return null;
  }

  /**
   * Render section
   * Positions notifications at the bottom right of the viewport
   * Maps through notifications array to render individual Notification components
   */
  return (
    <div className="fixed bottom-0 right-3">
      {notifications.map((notification) => (
        <Notification key={notification.id} {...notification} />
      ))}
    </div>
  );
};

export default NotificationsContainer;
